import * as _ from 'underscore'

import { OpConfigurationProfile, OpDeviceTypeProfileMap } from "../models/core"
import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { ColumnInfo } from "../models/custom"
import { OpReport } from "../models/dw"

export class DataProviderConfigurationProfile {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public deleteConfigurationProfile = (idConfigurationProfile: number): JQueryPromise<void> => {
        return this.dataProvider
            .sendRequestWithSession('OpxDeleteConfigurationProfile', { IdConfigurationProfile: idConfigurationProfile }, null)
            .then((data: any) => {
                
            })
    }


    public getConfigurationProfile = (id: number): JQueryPromise<OpConfigurationProfile> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetConfigurationProfile', { IdConfigurationProfile: id }, 'OpxGetConfigurationProfileResult')
            .then(data => {
                const result: OpConfigurationProfile = new OpConfigurationProfile(data)
                OpConfigurationProfile.loadNavigationProperties(this.dataProvider, [result])
                return result
            })
    }


    public getConfigurationProfileFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpConfigurationProfile>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdConfigurationProfile, 'OpxConfigurationProfileFilter', 'OpxConfigurationProfileFilterResult')
            .then(result => {
                console.log(result)
                return result
            })
    }


    public saveConfigurationProfile = (opObj: OpConfigurationProfile): JQueryPromise<OpConfigurationProfile> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSaveConfigurationProfile', { ToBeSaved: opObj.toJSON() }, 'OpxSaveConfigurationProfileResult')
            .then((data: any) => {
                const result: OpConfigurationProfile = new OpConfigurationProfile(data)

                OpConfigurationProfile.loadNavigationProperties(this.dataProvider, [result])

                return result
            })
    }

    public isConfigurationProfileUsed = (id: number): JQueryPromise<boolean> => {
        return this.dataProvider
            .sendRequestWithSession('OpxIsConfigurationProfileUsed', { IdConfigurationProfile: id }, 'OpxIsConfigurationProfileUsedResult')
            .then((result) => {
                return !!result
            })
    }

    public getAllDeviceTypeProfileMap(): JQueryPromise<OpDeviceTypeProfileMap[]> {
        return this.dataProvider.sendRequestWithSession('OpxGetAllDeviceTypeProfileMap', {}, 'OpxGetAllDeviceTypeProfileMapResult')
            .then((result: any[]) => {
                if (_.size(result) == null) {
                    return []
                }

                return _.map(result, (res: any) => new OpDeviceTypeProfileMap(res))
            })
    }

    // Public Methods End
}